import { Component, ViewChild, ViewContainerRef, ComponentRef, OnInit } from '@angular/core';
import { NavigationScrollService } from './services/navigation-scroll.service';
import { AppConfig } from '../config/appConfig';
import { ToastComponent } from './components/toast/toast.component';
import { ToastService } from './services/toast.service';
import { SeoService } from './services/seo.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { CookieConsentService } from './services/cookie-consent.service';
import { AppSettingsService } from './services/app-settings.service';
import { EmergencyContextPreloadService } from './services/emergency-context-preload.service';
import { AffiliateReferralTrackingService } from './services/affiliate-referral-tracking.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  @ViewChild('toastContainer', { read: ViewContainerRef }) toastContainer!: ViewContainerRef;

  title = AppConfig.title;
  currentUrl = '';

  constructor( 
    private toastService: ToastService, 
    private activatedRoute: ActivatedRoute, 
    private router: Router,
    private seoService: SeoService,
    private cookieConsentService: CookieConsentService,
    readonly appSettingsService: AppSettingsService,
    private readonly emergencyContextPreloadService: EmergencyContextPreloadService,
    private readonly affiliateReferralTrackingService: AffiliateReferralTrackingService,
    navigationScrollService: NavigationScrollService
) {
    void navigationScrollService;
    void this.emergencyContextPreloadService;
  }

  ngAfterViewInit() {
    this.toastService.registerContainer(this.toastContainer);
  }

  ngOnInit(): void {
     this.affiliateReferralTrackingService.init();
     this.cookieConsentService.init();
     this.currentUrl = this.router.url;
     this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.currentUrl = this.router.url;
        let route = this.activatedRoute.firstChild;
        while (route?.firstChild) {
          route = route.firstChild;
        }

        this.seoService.update(this.router.url, route?.snapshot.data ?? {});
      });
  }

  shouldShowDisabledPage(): boolean {
    if (this.appSettingsService.appEnabled()) {
      return false;
    }

    const allowRoutes = ['/login', '/admin'];
    return !allowRoutes.some(route => this.currentUrl.startsWith(route));
  }
}
